import { useAppServices } from "hook/services";
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import DeviceEditModal from "../Modal/Edit";
export default function DevicesData() {
  const AppService = useAppServices();
  const { locationId } = useParams();
  const [devices, setDevices] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [editData, setEditData] = useState<any>(null);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const toggleEditModal = () => setShowEditModal((prev) => !prev);

  const getDevices = async () => {
    const { response, error } = await AppService.phone_bridge.devices.filter({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setDevices(response.data);
      setLoading(false);
    } else {
      setDevices([]);
      setLoading(false);
    }
  };

  let pageLoad = true;
  const onload = () => {
    if (pageLoad) {
      getDevices();
      pageLoad = false;
    }
  };

  useEffect(() => {
    onload();
  }, []);

  const toggleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedRows(devices.map((acc: any) => acc._id));
    } else {
      setSelectedRows([]);
    }
  };

  const toggleSelectRow = (id: string, checked: boolean) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };
  const handleDelete = async (_id: string) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const { response, error } = await AppService.sub_account.delete({
          query: `_id=${_id}`,
        });

        if (response) {
          Swal.fire("Deleted!", "The record has been deleted.", "success");
          onload();
        } else {
          Swal.fire(
            "Error!",
            error?.message || "Something went wrong.",
            "error"
          );
        }
      } catch (err: any) {
        Swal.fire("Error!", err.message || "Delete failed.", "error");
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        header: (() => {
          const allSelected =
            selectedRows.length === devices.length && devices.length > 0;

          if (allSelected) {
            return (
              <input
                id="CheckboxAll"
                className="size-4 cursor-pointer"
                type="checkbox"
                checked
                onChange={(e) => toggleSelectAll(e.target.checked)}
              />
            );
          }
          return (
            <input
              id="CheckboxAll"
              className="size-4 cursor-pointer"
              type="checkbox"
              onChange={(e) => toggleSelectAll(e.target.checked)}
            />
          );
        })(),
        enableSorting: false,
        id: "checkAll",
        cell: (cell: any) => {
          const rowId = cell.row.original._id;
          if (selectedRows.includes(rowId))
            return (
              <input
                className="size-4 cursor-pointer"
                type="checkbox"
                checked
                onChange={(e) => toggleSelectRow(rowId, e.target.checked)}
              />
            );
          return (
            <input
              className="size-4 cursor-pointer"
              type="checkbox"
              onChange={(e) => toggleSelectRow(rowId, e.target.checked)}
            />
          );
        },
      },
      {
        header: "Device Model",
        accessorKey: "device_model",
        enableColumnFilter: false,
      },
      {
        header: "Android Version",
        accessorKey: "android_version",
        enableColumnFilter: false,
      },
      {
        header: "App Version",
        accessorKey: "app_version",
        enableColumnFilter: false,
      },
      {
        header: "Android ID",
        accessorKey: "android_id",
        enableColumnFilter: false,
      },
      {
        label: "Actions",
        accessorKey: "actions",
        enableColumnFilter: false,
        enableSorting: true,
        renderCell: (cell: any) => (
          <div className="d-flex gap-2 justify-content-center">
            <button
              className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "36px", height: "36px" }}
              title="Delete Device"
            >
              <i className="bi bi-trash"></i>
            </button>
          </div>
        ),
      },
    ],
    [selectedRows, devices]
  );
  return {
    loading: loading,
    devices: devices,
    selectedRows: selectedRows,
    resetSelectedRows: () => setSelectedRows([]),
    columns: columns,
    handleRefresh: onload,
    EditModel: (
      <DeviceEditModal
        handleRefresh={onload}
        show={showEditModal}
        toggle={toggleEditModal}
        editData={editData}
      />
    ),
  };
}
